<template>
  <button
    :class="[
      'passenger-selection-row m-0 p-0 btn btn-ghost',
      { 'is-selected': selected, 'has-seat': Boolean(seat) },
    ]"
    @click="
      () => {
        if (onClick) onClick();
      }
    "
  >
    <span class="passenger-selection-row__name">
      <span class="passenger-selection-row__name-text">{{
        formatPassengerName(passenger)
      }}</span>
      <span v-if="passenger.holding" class="thin">+ neonato</span>
      <vb-icon
        v-if="info_popover"
        v-b-popover.hover.top="info_popover"
        name="info"
        :size="12"
        color="AAA"
        class="passenger-selection-row__info"
      />
    </span>
    <span class="passenger-selection-row__end">
      <vb-icon
        v-if="seat"
        name="check_circle"
        :size="16"
        :color="color_success"
      />
    </span>
  </button>
</template>

<script>
import { formatPassengerName } from "@liveflight/utilities/mixins";
import { passenger_seat_hint } from "@liveflight/utilities/seat-map";
import { color_success } from "@liveflight/resources/colors";

export default {
  name: "passenger-selection-row",
  props: {
    passenger: Object,
    seat: Object,
    selected: {
      type: Boolean,
      default: false,
    },
    onClick: Function,
  },
  data() {
    return {
      formatPassengerName,
      color_success,
    };
  },
  computed: {
    info_popover() {
      return passenger_seat_hint(this.passenger);
    },
  },
};
</script>

<style lang="scss">
.passenger-selection-row {
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 0;

  &:not(:last-child) {
    padding-bottom: 12px !important;
    border-bottom: $card-border-width solid $card-border-color;
  }

  .passenger-selection-row__end {
    width: 24px;
    text-align: center;
    margin-left: auto;
    flex-shrink: 0;
    .vb-icon {
      display: inline-block;
      vertical-align: middle;
    }
  }

  .passenger-selection-row__name {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    color: $body-color;

    > * {
      flex-shrink: 0;
    }
  }

  .passenger-selection-row__name-text {
    flex-shrink: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.has-seat .passenger-selection-row__name {
    color: $success;
  }

  &.is-selected .passenger-selection-row__name-text {
    text-decoration: underline;
    font-weight: $vb-font-weight-semibold;
  }
}
</style>
